import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/images/logo-default.svg";
import logoCompany from "../../assets/images/logo-company.svg";
import { changeUser } from "../../core/service/api_profile";
import { useDispatch } from "react-redux";
import { setToken } from "../../core/feature/token/tokenSlice";
import { setUser } from "../../core/feature/user/userSlice";
import { setSwitchAccounts } from "../../core/feature/user/switchAccountSlice";
import * as api_balance from "../../core/service/api_balance";
import { setBalance } from "../../core/feature/balance/balanceSlice";
import { useAppSelector } from "../../core/feature/hooks";
import { setCustomApp } from "../../core/feature/company/customAppsSlice";
import { getCustomApps } from "../../core/service/api";
const getInitials = (name: string = "") => {
  if (!name) return "";
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
};

export const SelectAccountMobile = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const language: String = useAppSelector((state) => state.language.language);

  const [accounts, setAccounts] = useState<any[]>([]);
  const [companies, setCompanies] = useState<any[]>([]);
  const [userData, setUserData] = useState<any>({});
  const [selectedUserId, setSelectedUserId] = useState<string | number | null>(
    null,
  );

  const mappedData = useMemo(() => {
    const mainAccount =
      userData && userData.id
        ? [
            {
              userId: userData.id,
              name: userData.name,
              companyName: companies.find(
                (company) => company.id === userData.accounts?.[0]?.companyId,
              )?.name,
              companyId: userData.accounts?.[0]?.companyId,
            },
          ]
        : [];

    const otherAccounts = accounts.map((account) => ({
      userId: account.userId ?? account.id,
      name: account.name,
      companyName: companies.find((company) => company.id === account.companyId)
        ?.name,
      companyId: account.companyId,
    }));

    const combined = [...mainAccount, ...otherAccounts];
    // deduplicate by userId + companyId, keep first occurrence
    const seen = new Set();
    return combined.filter((item) => {
      const key = `${item.userId}-${item.companyId}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }, [accounts, companies, userData]);

  useEffect(() => {
    console.log("location.state?.data", location.state?.data);
    if (!location.state?.data) {
      window.location.href = "/login";
    }

    if (location.state?.data?.accounts) {
      setAccounts(location.state?.data?.accounts);
    }

    if (location.state?.data?.companies) {
      setCompanies(location.state?.data?.companies);
    }

    if (location.state?.data?.user) {
      setUserData(location.state?.data?.user);
    }
  }, [location.state?.data]);

  useEffect(() => {
    if (mappedData.length > 0 && selectedUserId === null) {
      setSelectedUserId(mappedData[0].userId);
    }
  }, [mappedData, selectedUserId]);

  const handleContinue = async () => {
    try {
      const selected = mappedData.find(
        (item) => item.userId === selectedUserId,
      );
      console.log("selected account", selected);
      // TODO: lanjutkan proses login dengan akun terpilih
      const resp = await changeUser(selected?.userId, selected?.companyId);
      const balance = await api_balance.getBalance();
      if (balance.data && balance.data.balance) {
        localStorage.setItem("balance", balance.data.balance);
        dispatch(setBalance(balance.data.balance));
      }
      if (resp.data) {
        dispatch(
          setToken(resp.headers.authorization.replaceAll("Bearer ", "")),
        );
        localStorage.setItem("auto_login", "1");
        dispatch(setUser(resp.data.user));

        dispatch(
          setSwitchAccounts({
            companyName: resp.data.activeCompany.name,
            companyId: resp.data.activeCompany.id,
            userId: resp.data.user.id,
            name: resp.data.user.name,
            photoUrl: resp.data.user.photoUrl,
            token: resp.headers.authorization.replaceAll("Bearer ", ""),
            lastService: resp.data.user.lastService || "KATALIS",
          }),
        );
        var languageUpper = language.toUpperCase();
        console.log(resp.data.activeCompany.customApps);
        if (resp.data.activeCompany.customApps) {
          const respCustomApp = await getCustomApps(
            resp.data.activeCompany.id,
            languageUpper,
          );
          console.log("respCustomApp: ", respCustomApp);
          dispatch(setCustomApp(respCustomApp.data));
        }
        return navigate("/home", { replace: true });
      }

      // navigate("/home", { replace: true });
    } catch (error) {
      console.error("Error during account switch:", error);
    }
  };

  function maskName(name: string) {
    return String(name)
      .trim()
      .split(/\s+/)
      .map((word) => word[0] + "*".repeat(Math.max(word.length - 1, 0)))
      .join(" ");
  }

  return (
    <div className="min-h-screen bg-[#F3F4FB] font-poppins">
      <div className="mx-auto flex min-h-screen w-full max-w-[480px] flex-col bg-[#F7F8FD] px-6 pb-6 pt-8">
        {/* Logo */}
        <div className="flex justify-center pt-4">
          <img src={logo} alt="PSP Mobile" className="w-[228px]" />
        </div>

        {/* Title */}
        <h1 className="mt-12 text-[22px] font-bold leading-7 text-[#0054E6]">
          Pilih Akun
        </h1>
        <p className="mt-3 text-[14px] font-normal leading-5 text-black">
          Pilih profil yang ingin digunakan. Anda dapat menggantinya kembali
          melalui menu akun.
        </p>

        {/* Account list */}
        <div className="mt-6 flex flex-col gap-3">
          {mappedData.map((item: any, index: number) => {
            const isSelected =
              selectedUserId !== null
                ? item.userId === selectedUserId
                : index === 0;
            return (
              <button
                key={`${item.userId}-${item.companyId}-${index}`}
                type="button"
                onClick={() => setSelectedUserId(item.userId)}
                className={`flex w-full items-center gap-4 rounded-xl bg-white px-4 py-3 text-left transition-colors ${
                  isSelected
                    ? "border-2 border-blue-600"
                    : "border border-[#B9B9B9]"
                }`}
              >
                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#DCE8FF] text-[15px] font-bold text-[#164998]">
                  {getInitials(item.name)}
                </div>
                <div className="flex min-w-0 flex-col">
                  <span className="truncate text-[15px] font-bold leading-6 text-black">
                    {maskName(item.name) || "-"}
                  </span>
                  <span className="truncate text-[14px] font-normal leading-5 text-black">
                    {maskName(item.companyName) || "-"}
                  </span>
                </div>
              </button>
            );
          })}

          {mappedData.length === 0 && (
            <div className="rounded-xl border border-dashed border-[#B9B9B9] bg-white px-4 py-6 text-center text-sm text-[#8F8F8F]">
              Tidak ada akun tersedia
            </div>
          )}
        </div>

        {/* CTA */}
        <button
          type="button"
          onClick={handleContinue}
          className="mt-8 h-[52px] w-full rounded-xl bg-[#0054E6] text-[15px] font-bold text-white shadow-sm active:bg-[#164998]"
        >
          Lanjutkan dengan Akun Ini
        </button>

        {/* Footer */}
        <div className="mt-auto flex flex-col items-center pt-20">
          <p
            className="text-xs font-normal text-center"
            style={{ color: "#8F8F8F" }}
          >
            Powered By
          </p>
          <img src={logoCompany} alt="TKI" className="mt-3 w-28" />
        </div>
      </div>
    </div>
  );
};
